import { validateReservationEngineVersion } from '../../utils/utils';
import { api, apiAxiosInstance } from './api';

const vehicleData = `{ status price details seats id default_file owner_vehicle_group vin name services_shared customer_vehicle_group vehicle_group license_plate brokers color  vehicle_type{make model asset_class description year id} vehicle_group}`;

export const fetchVehicles = (params, options = {}, queryFields = '') => {
  const queryString = Object.keys(params)
    .map((key) => key + '=' + params[key])
    .join('&');
  const url = validateReservationEngineVersion(`/vehicle?${queryString}`);

  const graphQLFields = queryFields ? queryFields : `{id name display_name}`;

  options['headers'] = {
    'Query-Fields': graphQLFields,
  };

  return api.get(url, undefined, options);
};

export const fetchVehicleById = (id, options = {}, queryFields = '') => {
  const graphQLFields = queryFields ? queryFields : vehicleData;
  const url = validateReservationEngineVersion(`/vehicle/${id}`);

  options['headers'] = {
    'Query-Fields': graphQLFields,
  };

  return api.get(url, undefined, options);
};

export const deleteVehicle = (id) => {
  return api.delete(`/vehicle/${id}`);
};

export const fetchVehicleOrgsById = (id) => {
  return api.get(`/vehicle/${id}/organization?all=true`);
};

export const getBrokers = (id) => {
  return api.get(`/vehicle/${id}/broker`);
};

export const fetchVehiclesAssetClasses = (params) => {
  return api.get(`/vehicle/asset_class`, params);
};

export const fetchVehiclesTypes = (params, options) => {
  return api.get(`/vehicle/vehicle_type`, params, options);
};

export const createVehicleType = (params) => {
  return api.post(`/vehicle/vehicle_type`, params);
};

export const updateVehicleType = (id, params) => {
  return api.put(`/vehicle/vehicle_type/${id}`, params);
};

export const fetchVehicleTypeById = (id) => {
  return api.get(`/vehicle/vehicle_type/${id}`);
};

export const fetchVehicleTypeCategories = (params) => {
  return api.get(`/vehicle/vehicle_type/category`, params);
};

export const createVehicle = (params) => {
  const url = validateReservationEngineVersion(`/vehicle`);
  return api.post(url, params);
};

export const addBroker = (id, params) => {
  return api.post(`/vehicle/${id}/broker`, params);
};

export const updateVehicle = (id, params, options = {}, queryFields = '') => {
  const graphQLFields = queryFields ? queryFields : vehicleData;
  const url = validateReservationEngineVersion(`/vehicle/${id}`);
  options['headers'] = {
    'Query-Fields': graphQLFields,
  };
  return api.put(url, params, options);
};

export const addServiceToVehicle = (id, payload) => {
  return api.post(`/vehicle/${id}/organization`, payload);
};

export const removeServiceToVehicle = (id, organization_id) => {
  return api.delete(`/vehicle/${id}/organization/${organization_id}`);
};

export const changeVehicleGroup = (id, payload, options = {}, graphQLFields = null) => {
  graphQLFields = graphQLFields || vehicleData;
  const url = validateReservationEngineVersion(`/vehicle/${id}/vehicle_group`);
  options['headers'] = {
    'Query-Fields': graphQLFields,
  };
  return api.post(url, payload, options);
};

export const getVehicleServices = (id) => {
  return api.get(`/vehicle/${id}/organization`);
};

export const getAvailablesVehicleBrokers = (id) => {
  return api.get(`/vehicle/broker`);
};

export const changeVehicleStatus = (id, payload, options = {}, graphQLFields = null) => {
  graphQLFields = graphQLFields || vehicleData;
  const url = validateReservationEngineVersion(`/vehicle/${id}/status`);
  options['headers'] = {
    'Query-Fields': graphQLFields,
  };
  return api.post(url, payload, options);
};

export const changeMultipleVehicleStatus = (payload) => {
  return api.post(`/vehicle/bulk/update_status`, payload);
};

export const setVehicleAction = (id, action) => {
  return api.post(`/vehicle/${id}/action`, { action });
};

export const uploadVehicleImage = (id, payload) => {
  return api.post(`/vehicle/${id}/image`, payload);
};

export const setVehicleProfileImage = (id, payload) => {
  return api.put(`/vehicle/${id}/image`, payload);
};

export const uploadVehicleTypeImage = (id, payload) => {
  return api.post(`/vehicle/vehicle_type/${id}/image`, payload);
};

export const setVehicleTypeProfileImage = (id, payload) => {
  return api.put(`/vehicle/vehicle_type/${id}/image`, payload);
};

export const deleteVehicleTypeImages = (id, images) => {
  return apiAxiosInstance
    .delete(`/vehicle/vehicle_type/${id}/image`, {
      data: {
        image_id: images,
      },
    })
    .catch((err) => {
      return err.response;
    });
};

export const removeBroker = (id, broker) => {
  return api.delete(`/vehicle/${id}/broker/${broker}`);
};

export const deleteVehicleImages = (id, images) => {
  return apiAxiosInstance
    .delete(`/vehicle/${id}/image`, {
      data: {
        image_id: images,
      },
    })
    .catch((err) => {
      return err.response;
    });
};

export const bulkUpload = (payload) => {
  return api.post(`/vehicle/bulk_create`, payload, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  });
};

export const bulkServiceSharing = (payload) => {
  return api.post(`/vehicle/organization`, payload);
};

export const bulkUnshareService = (payload) => {
  return apiAxiosInstance
    .delete('/vehicle/organization', {
      data: payload,
    })
    .catch((err) => {
      return err.response;
    });
};

export const fetchVehicleStats = () => {
  const url = validateReservationEngineVersion(`/vehicle/stats`);
  return api.get(url);
};

export const getBrokerSettings = (id, slug) => {
  return api.get(`/vehicle/${id}/broker/${slug}/settings`);
};

export const putBrokerSettings = (id, slug, payload) => {
  return api.put(`/vehicle/${id}/broker/${slug}/settings`, payload);
};

export const fetchVehicleStatusesById = (id, params) => {
  const queryString = Object.keys(params)
    .map((key) => key + '=' + params[key])
    .join('&');
  const url = `/vam/vehicle/${id}/statuses?${queryString}`;

  return api.get(url);
};
